import { render, staticRenderFns } from "./RequestListView.vue?vue&type=template&id=561d6710&scoped=true&"
import script from "./RequestListView.vue?vue&type=script&lang=ts&"
export * from "./RequestListView.vue?vue&type=script&lang=ts&"
import style0 from "./RequestListView.vue?vue&type=style&index=0&id=561d6710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d6710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561d6710')) {
      api.createRecord('561d6710', component.options)
    } else {
      api.reload('561d6710', component.options)
    }
    module.hot.accept("./RequestListView.vue?vue&type=template&id=561d6710&scoped=true&", function () {
      api.rerender('561d6710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/request/RequestListView.vue"
export default component.exports